/**
 * jQuery 전역 등록 — Summernote 초기화에 필요
 * main.ts에서 최우선으로 import해야 합니다.
 */
import $ from 'jquery';

(window as any).$ = $;
(window as any).jQuery = $;
